Greenmile.EventLog = Greenmile.EventLog || {};

Greenmile.EventLog.FilterModal = function (routeId) {

  this.screenList = Monet.Session.RouteDetail.screensList[routeId];
  this.route = this.screenList.model;

  this.show = () => {

    this.modalForm = new Monet.Form.Modal('#routeMaps_' + this.route.id, {
        width: 350,
        height: 480
    }, null, '#routeMaps_' + this.route.id + ' .containerRouteDetail');
    this.modalForm.showModalForm();

    const container = document.querySelector(`${this.modalForm.selector} .popupFormContainer`);
    container.setAttribute('id', 'routes_event_filter');
    container.style.overflow = 'visible';

    this.appendLookup(container);
    this.appendSaveButton(container);

  };

  this.appendLookup = container => {
      this.lookupList = new Monet.UI.Fields.PowerLookupList();
      this.lookupList.setNameSpace('EventType');
      this.lookupList.setDisplayKey('description');
      this.lookupList.setLookUpEntity('EventType');
      this.lookupList.setTextLabel(Monet.I18n.getResourcesByKey('eventType.userinterface.description'));
      const values = this.screenList.eventsFilter;
      if (values && values.length) {
        this.lookupList.setValue(values.map(value => (value.id)));
      }
      container.appendChild(this.lookupList.render());
  };

  this.appendSaveButton = container => {
      const saveButton = document.createElement('input');
      const saveAction = () => {
        const values = this.lookupList.getFullValue();
        this.screenList.eventsFilter = values;
        this.screenList.eventRoute.requestEventsAndAddOnMap();
        this.modalForm.closeModalWindow();
      };
      saveButton.type = 'button';
      saveButton.value = Monet.I18n.getResourcesByKey('FilterEventLogs.btnFilter');
      saveButton.removeEventListener('click', saveAction);
      saveButton.id = 'saveEventLogFilters';
      saveButton.addEventListener('click', saveAction);
      container.appendChild(saveButton);
  };

};
